import type { Translator } from '../i18n/i18n'

export type KRideSurveyAnswer = 'opened' | 'install' | 'failed' | 'unknown'

interface KRideReturnSurveyProps {
  t: Translator
  onAnswer: (answer: KRideSurveyAnswer) => void
}

export function KRideReturnSurvey({ t, onAnswer }: KRideReturnSurveyProps) {
  const answers: Array<{ id: KRideSurveyAnswer; label: string }> = [
    { id: 'opened', label: t('krideSurveyOpened') },
    { id: 'install', label: t('krideSurveyInstall') },
    { id: 'failed', label: t('krideSurveyFailed') },
    { id: 'unknown', label: t('krideSurveyUnknown') },
  ]

  return (
    <section className="return-survey" aria-labelledby="kride-survey-heading">
      <h2 id="kride-survey-heading">{t('krideSurveyQuestion')}</h2>
      <div className="survey-options">
        {answers.map((answer) => (
          <button type="button" key={answer.id} onClick={() => onAnswer(answer.id)}>
            {answer.label}
          </button>
        ))}
      </div>
    </section>
  )
}
